import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { showNotification } from '@/utils/notificationUtils';

export type requestDTO = {

    id?: number | string;
    name:any;
    phone: string;
    email: string;
    instituteId?: any;
    designation?: string
};

export const updateContact = ({ id, name,phone,email, instituteId, designation}: requestDTO) => {
        return axios.post(`/superadmin/update-contact`, {id,  name,phone,email,  instituteId, designation});
};

type UseAddUserOptions = {
  config?: MutationConfig<typeof updateContact>;
};

export const useUpdateContact = ({ config }: UseAddUserOptions = {}) => {
  const { addNotification } = useNotificationStore();
  return useMutation({
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'Contact updated successfully',
      });
    },
    ...config,
    mutationFn: updateContact,
  });
};
